import { ISteppedGabionResults } from '../../../../api/IApiResponse';
import { IChannelGeometrySteppedWeirForm } from '../../../InputForm/ChannelGeometry/IChannelGeometry';
import { IStillingBasinSteppedWeirSlopedWeirForm } from '../../../InputForm/StillingBasin/IStillingBasin';
import { IWeirGeometrySteppedWeirForm } from '../../../InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySteppedWeirForm } from '../../../InputForm/WingsGeometry/IWingsGeometry';

export interface ISteppedWeirLongitudinalProps {
    weirGeometry: IWeirGeometrySteppedWeirForm;
    stillingBasin: IStillingBasinSteppedWeirSlopedWeirForm;
    wingsGeometry: IWingsGeometrySteppedWeirForm;
    result?: ISteppedGabionResults;
    inspectAttribute: (width: number, height: number) => void;
    scale: number;
    isImperial: boolean;
}

export interface ISteppedWeirCrossProps {
    wingsGeometry: IWingsGeometrySteppedWeirForm;
    weirGeometry: IWeirGeometrySteppedWeirForm;
    riverGeometry: IChannelGeometrySteppedWeirForm;
    result?: ISteppedGabionResults;
    scale: number;
    isImperial: boolean;
}

export enum EStepRatio {
    oneToOne = 1 / 1,
    oneToTwo = 1 / 2,
    oneToThree = 1 / 3,
    oneToFive = 1 / 5,
}
